module.exports = __webpack_public_path__ + "static/img/smart-plating_256.b5744fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smart-plating_256.png
// module id = 2XXZ
// module chunks = 0